module.exports = __webpack_public_path__ + "img/45.98ea3ed3.svg";